import type { ReceiptReportItemDto } from "@/api/dtos";
import type { ReceiptReportItem } from "@/api/report/_models/ReceiptReport";

/** DTO → domain for a receipt report row. */
export const toReceiptReportItemFromDto = (dto: ReceiptReportItemDto): ReceiptReportItem => {
  return {
    date: dto.date,
    item: dto.item,
    expectedQuantity: dto.expectedQuantity,
    receivedQuantity: dto.receivedQuantity,
    container: dto.container,
  };
};
